import { LoadingButton } from 'library/buttons';
import { Drawer } from 'library/drawer';
import { ReactNode, forwardRef } from 'react';
import { DrawerProps } from './Drawer';

export interface ConfirmationDrawerProps extends Omit<DrawerProps, 'title' | 'children'> {
    title: ReactNode;
    message: ReactNode;
    onConfirm?: () => void;
    isConfirming?: boolean;
    confirmText?: string;
    confirmBtnColor?: 'primary' | 'danger';
    confirmLoadingText?: string;
    cancelText?: string;
    onCancel?: () => void;
    isCancelling?: boolean;
    cancelLoadingText?: string;
}

const ConfirmationDrawer = forwardRef<HTMLDivElement, ConfirmationDrawerProps>((props, ref) => {
    const {
        show,
        onClose,
        title,
        message,
        onConfirm,
        confirmLoadingText,
        onCancel,
        cancelLoadingText,
        isConfirming = false,
        confirmText = 'Confirm',
        confirmBtnColor = 'danger',
        isCancelling = false,
        cancelText = 'Cancel',
        ...rest
    } = props;

    const handleCancelClick = () => {
        onClose();

        onCancel?.();
    };

    return (
        <Drawer ref={ref} show={show} onClose={onClose} {...rest}>
            <h4>{title}</h4>

            <div className="text-sm leading-6 text-grayscale-500 font-medium mt-4">{message}</div>

            <div className="flex gap-4 mt-4">
                <LoadingButton
                    type="button"
                    color="secondary"
                    className="font-medium text-grayscale-500"
                    size="sm"
                    onClick={handleCancelClick}
                    isLoading={isCancelling}
                    loadingText={cancelLoadingText}
                >
                    {cancelText}
                </LoadingButton>

                <LoadingButton
                    type="button"
                    color={confirmBtnColor}
                    size="sm"
                    onClick={onConfirm}
                    isLoading={isConfirming}
                    loadingText={confirmLoadingText}
                >
                    {confirmText}
                </LoadingButton>
            </div>
        </Drawer>
    );
});

export default ConfirmationDrawer;
